<template>
    <modal
        :id="CONFIRM_MODAL"
        ref="modal"
        :visible="isConfirmModalVisible"
        :mods="mods"
        @close="onClose">
        <template #title>
            {{ options?.title ?? $t('action.delete') }}
        </template>

        <p class="m-0">{{ options?.message }}</p>

        <template #actions>
            <vz-button type="button" text @click="close('cancel')">
                {{ $t('action.cancel') }}
            </vz-button>
            <vz-button type="button" class="confirm" light @click="close('submit')">
                {{ options?.confirmLabel ?? $t('action.delete') }}
            </vz-button>
        </template>
    </modal>
</template>

<script setup lang="ts">
    import { CONFIRM_MODAL, useConfirmModal } from '@/composables/useConfirmModal';
    import type { ModalCloseParams, ModalMods } from './Modal.vue';

    const modalStore = useModalStore();
    const { settle } = useConfirmModal();
    const modalRef = useTemplateRef('modal');

    const isConfirmModalVisible = computed(() => modalStore.isVisible(CONFIRM_MODAL));
    const options = computed(() => modalStore.getModalOptions(CONFIRM_MODAL));

    const mods = computed<ModalMods | undefined>(() =>
        options.value?.variant ? 'mod-info' : undefined,
    );

    const close = (reason: ModalCloseParams['type']) => modalRef.value?.close(reason);

    const onClose = ({ type }: ModalCloseParams) => {
        // 'submit' == confirmed; 'cancel' (button, X, or escape) == declined
        settle(type === 'submit');
    };
</script>
